import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HeadersService } from '../header.service';

@Injectable({
  providedIn: 'root'
})
export class ControleAcessosSigService {
  private readonly url = `${environment.apiUrl}/api/v1/controle-acessos-sig`;

  constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'controle-acesse-sig.service.ts', url: this.url });
  }

  public logar(id: string, token: string): Observable<any> {
    return this.http.post<any>(`${this.url}/logar`, {
      chaveAcesso: token,
      idCliente: id
    });
  }
}
